import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FormControl from '@mui/material/FormControl';

import {
    Box,
    Grid,
    Typography,
    Tooltip,
    IconButton,
    Chip,
    InputBase,
    Divider,
    Snackbar,
    Alert,
    Modal,
    Card,
    CardContent,
    Stack,
    Avatar,
    TextField,
    FormHelperText,
    Button,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';

import MenuItem from '@mui/material/MenuItem';

import Skeleton from '@mui/material/Skeleton';

import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';

import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import TimelineIcon from '@mui/icons-material/Timeline';
import CloseIcon from '@mui/icons-material/Close';
import CallIcon from '@mui/icons-material/Call';
import ForumIcon from '@mui/icons-material/Forum';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: '95%',
        md: 900
    },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 3,
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const InstitutesComp = (props) => {
    const [openDetailsModal, setOpenDetailsModal] = React.useState(false);
    const [selectedInstitute, setSelectedInstitute] = React.useState({});

    const FormatDateTime = (date) => {

        if (!date) return 'N/A';

        let formatDate =
            new Date(
                new Date(date).getTime()
                - (new Date(date).getTimezoneOffset() * 60000)
            )
                .toISOString()
                .substr(0, 19)
                .replace('T', ' ');

        return formatDate;
    };

    const formatDuration = (seconds) => {

        if (!seconds) return 'Not Available';

        const mins = Math.floor(seconds / 60);

        const secs = seconds % 60;

        return `${mins}m ${secs}s`;

    };

    const ViewInstituteDetails = (item) => {
        setSelectedInstitute(item);
        setOpenDetailsModal(true);
    };

    return (
        <Box>

            {/* TOP BAR */}
            <Box>

                <Grid container spacing={2}>

                    <Grid item xs={12} md={4} mt={2}>

                        <Paper
                            component="form"
                            sx={{
                                p: '2px 4px',
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%'
                            }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search By Institute..."
                                value={props.mystate.leadObj?.txtInstituteSearchName || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteSearchName')
                                }
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <SearchIcon
                                    onClick={() =>
                                        props.SearchLeadList('direct', '')
                                    }
                                />
                            </IconButton>

                            <Divider
                                sx={{ height: 28, m: 0.5 }}
                                orientation="vertical"
                            />

                            <IconButton sx={{ p: '10px' }}>
                                <CachedIcon
                                    onClick={() =>
                                        props.SearchLeadList('reload', '')
                                    }
                                />
                            </IconButton>

                        </Paper>

                    </Grid>

                    <Grid item xs={12} md={8} mt={2} textAlign={'right'}>

                        <Tooltip arrow title="New Institute">

                            <IconButton
                                onClick={() =>
                                    props.NavigateTo('institute/new')
                                }
                                className='grey-theme-btn'
                            >
                                <AddIcon />
                            </IconButton>

                        </Tooltip>

                        <Tooltip arrow title="Filter">

                            <IconButton
                                onClick={() => props.ToggleFilter()}
                                className='grey-theme-btn'
                            >
                                <FilterListIcon />
                            </IconButton>

                        </Tooltip>

                    </Grid>

                </Grid>

            </Box>

            {/* TABLE */}
            <Box mt={3}>

                {
                    props.mystate.getLeadList === false ?

                        window.innerWidth > 567 ?

                            <Paper
                                sx={{
                                    width: '100%',
                                    overflow: 'hidden'
                                }}
                            >

                                <TableContainer
                                    sx={{
                                        maxHeight: 'calc(100vh - 250px)'
                                    }}
                                >

                                    <Table stickyHeader>

                                        <TableHead>

                                            <TableRow>

                                                <TableCell className='table-head-cell'>
                                                    Sr No
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    Added Date
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    Institute
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    POC Details
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    Languages
                                                </TableCell>



                                                {/* OWNER DETAILS */}
                                                <TableCell className='table-head-cell'>
                                                    Owner
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    Stage
                                                </TableCell>
                                                <TableCell className='table-head-cell'>
                                                    Last Call
                                                </TableCell>

                                                <TableCell className='table-head-cell'>
                                                    Action
                                                </TableCell>

                                            </TableRow>

                                        </TableHead>

                                        <TableBody>

                                            {
                                                props.mystate.instituteList?.length > 0 ?

                                                    props.mystate.instituteList.map((item, i) => (

                                                        <TableRow
                                                            hover
                                                            key={item._id}
                                                        >

                                                            {/* SR NO */}
                                                            <TableCell>

                                                                {
                                                                    (
                                                                        (
                                                                            props.mystate.setNo - 1
                                                                        )
                                                                        *
                                                                        props.mystate.perSet
                                                                    )
                                                                    + i + 1
                                                                }

                                                            </TableCell>

                                                            {/* DATE */}
                                                            <TableCell>

                                                                {
                                                                    FormatDateTime(
                                                                        item.institute_added_on
                                                                    )
                                                                }

                                                            </TableCell>

                                                            {/* INSTITUTE */}
                                                            <TableCell>

                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {item.institute_name}
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    {item.institute_type}
                                                                </Typography>

                                                                <br />

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    {item.institute_city}
                                                                </Typography>

                                                            </TableCell>

                                                            {/* POC */}
                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {
                                                                        item.institute_uprn_poc_name || 'NA'
                                                                    }
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    {
                                                                        item.institute_uprn_poc_mobile
                                                                    }
                                                                </Typography>

                                                                <br />

                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{ lineBreak: 'anywhere', width: 150 }}
                                                                >
                                                                    {
                                                                        item.institute_uprn_poc_email
                                                                    }
                                                                </Typography>

                                                            </TableCell>

                                                            {/* LANGUAGES */}
                                                            <TableCell>

                                                                {
                                                                    item.institute_core_languages?.map(
                                                                        (lang, idx) => (

                                                                            <Chip
                                                                                key={idx}
                                                                                label={lang}
                                                                                size="small"
                                                                                sx={{
                                                                                    mr: 0.5,
                                                                                    mb: 0.5
                                                                                }}
                                                                            />

                                                                        )
                                                                    )
                                                                }

                                                            </TableCell>

                                                            {/* OWNER DETAILS */}
                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {
                                                                        item.lead_owner_name || 'N/A'
                                                                    }
                                                                </Typography>

                                                                {
                                                                    item.lead_owner_profile &&
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="text.secondary"
                                                                    >
                                                                        {
                                                                            item.lead_owner_profile
                                                                        }
                                                                    </Typography>
                                                                }

                                                            </TableCell>

                                                            {/* STAGE */}
                                                            <TableCell>

                                                                <Chip
                                                                    label={
                                                                        item.lead_stage || 'N/A'
                                                                    }
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: '#042740',
                                                                        color: '#fff'
                                                                    }}
                                                                />

                                                            </TableCell>

                                                            <TableCell>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        fontSize: 10
                                                                    }}
                                                                >
                                                                    {
                                                                        item.last_call_time
                                                                    }
                                                                </Typography>

                                                                {
                                                                    item.last_call_by &&
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="text.secondary"
                                                                    >
                                                                        {
                                                                            item.last_call_by
                                                                        }
                                                                    </Typography>
                                                                }

                                                            </TableCell>

                                                            {/* ACTION */}
                                                            <TableCell>

                                                                <Box
                                                                    sx={{
                                                                        display: 'grid',
                                                                        gridTemplateColumns: 'repeat(2, 1fr)',
                                                                        gap: 1,
                                                                        justifyItems: 'center'
                                                                    }}
                                                                >

                                                                    {/* VIEW */}
                                                                    <Tooltip arrow title='View Details'>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                ViewInstituteDetails(item)
                                                                            }
                                                                        >
                                                                            <VisibilityIcon
                                                                                sx={{
                                                                                    color: '#0284c7'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                    {/* EDIT */}
                                                                    <Tooltip arrow title='Edit Institute'>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.NavigateTo(
                                                                                    'institute/' + item._id
                                                                                )
                                                                            }
                                                                        >
                                                                            <EditIcon
                                                                                className='grey-theme-btn'
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                    {/* CALL */}
                                                                    <Tooltip arrow title='Call Institute'>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.MakeNewCall(item)
                                                                            }
                                                                        >
                                                                            <CallIcon
                                                                                sx={{
                                                                                    color: '#16a34a'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                    {/* TIMELINE */}
                                                                    <Tooltip arrow title='View Timeline'>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                props.GetTimelineData(item._id)
                                                                            }
                                                                        >
                                                                            <TimelineIcon
                                                                                sx={{
                                                                                    color: '#7c3aed'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>

                                                                </Box>

                                                            </TableCell>

                                                        </TableRow>

                                                    ))

                                                    :

                                                    <TableRow>

                                                        <TableCell
                                                            colSpan={9}
                                                            align="center"
                                                        >

                                                            <Typography py={3}>
                                                                No Institutes Found
                                                            </Typography>

                                                        </TableCell>

                                                    </TableRow>
                                            }

                                        </TableBody>

                                    </Table>

                                </TableContainer>



                            </Paper>

                            :

                            <Box>

                                {
                                    props.mystate.instituteList?.map((item, i) => (

                                        <Card
                                            key={item._id}
                                            sx={{
                                                mb: 2,
                                                borderRadius: 3,
                                                boxShadow: 2
                                            }}
                                        >

                                            <CardContent>

                                                {/* HEADER */}

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-start',
                                                        mb: 1
                                                    }}
                                                >

                                                    <Box>

                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: '#042740'
                                                            }}
                                                        >
                                                            {item.institute_name}
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            📍 {item.institute_city || 'N/A'}
                                                        </Typography>

                                                    </Box>

                                                    <Chip
                                                        label={item.lead_stage || 'N/A'}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: '#042740',
                                                            color: '#fff'
                                                        }}
                                                    />

                                                </Box>
                                                {/* POC */}

                                                <Box sx={{ mb: 1 }}>

                                                    <Typography variant="body2">

                                                        <b>POC:</b>
                                                        {' '}
                                                        {item.institute_uprn_poc_name || 'N/A'}
                                                        {' | '}

                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                color: '#1976d2',
                                                                cursor: 'pointer',
                                                                fontWeight: 600,
                                                                textDecoration: 'underline'
                                                            }}
                                                            onClick={() => props.MakeNewCall(item)}
                                                        >
                                                            {item.institute_uprn_poc_mobile || 'N/A'}
                                                        </Typography>

                                                    </Typography>

                                                </Box>

                                                {/* OWNER + LAST CALL */}

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-start',
                                                        mb: 1
                                                    }}
                                                >

                                                    <Box>

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            Owner
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {item.lead_owner_name || 'N/A'}
                                                        </Typography>

                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            textAlign: 'right'
                                                        }}
                                                    >

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            Last Call
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {item.last_call_time || 'N/A'}
                                                        </Typography>

                                                        {
                                                            item.last_call_by && (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                >
                                                                    By {item.last_call_by}
                                                                </Typography>
                                                            )
                                                        }

                                                    </Box>

                                                </Box>

                                                {/* LANGUAGES */}

                                                {
                                                    item.institute_core_languages?.length > 0 && (
                                                        <Box sx={{ mb: 1 }}>

                                                            {
                                                                item.institute_core_languages.map(
                                                                    (lang, idx) => (

                                                                        <Chip
                                                                            key={idx}
                                                                            label={lang}
                                                                            size="small"
                                                                            sx={{
                                                                                mr: 0.5,
                                                                                mb: 0.5
                                                                            }}
                                                                        />

                                                                    )
                                                                )
                                                            }

                                                        </Box>
                                                    )
                                                }

                                                {/* FOOTER */}

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        pt: 1,
                                                        borderTop: '1px solid #e5e7eb'
                                                    }}
                                                >

                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                    >
                                                        {
                                                            FormatDateTime(
                                                                item.institute_added_on
                                                            )
                                                        }
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            gap: 1
                                                        }}
                                                    >

                                                        {/* VIEW */}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                ViewInstituteDetails(item)
                                                            }
                                                        >
                                                            <VisibilityIcon
                                                                sx={{
                                                                    color: '#0284c7'
                                                                }}
                                                            />
                                                        </IconButton>

                                                        {/* EDIT */}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                props.NavigateTo(
                                                                    'institute/' + item._id
                                                                )
                                                            }
                                                        >
                                                            <EditIcon />
                                                        </IconButton>

                                                        {/* CALL */}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                props.MakeNewCall(item)
                                                            }
                                                        >
                                                            <CallIcon
                                                                sx={{
                                                                    color: '#16a34a'
                                                                }}
                                                            />
                                                        </IconButton>

                                                        {/* TIMELINE */}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                props.GetTimelineData(item._id)
                                                            }
                                                        >
                                                            <TimelineIcon
                                                                sx={{
                                                                    color: '#7c3aed'
                                                                }}
                                                            />
                                                        </IconButton>

                                                    </Box>

                                                </Box>

                                            </CardContent>

                                        </Card>

                                    ))
                                }

                            </Box>


                        :

                        <Box>

                            <Skeleton height={75} />

                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                height={250}
                            />

                            <Skeleton height={75} />

                        </Box>
                }

                {
                    props.mystate.instituteList.length > 0 ?


                        <TablePagination
                            rowsPerPageOptions={[10, 50, 100]}
                            component="div"
                            count={props.mystate.totalRecords}
                            rowsPerPage={props.mystate.perSet}
                            page={props.mystate.setNo - 1}
                            onPageChange={(e) =>
                                props.HandleChangePage(
                                    e,
                                    props.mystate.setNo - 1
                                )
                            }
                            onRowsPerPageChange={(e) =>
                                props.HandleChangeRowsPerPage(e)
                            }
                        />

                        :
                        null
                }

            </Box>

            {/* DETAILS MODAL */}
            <Modal
                open={openDetailsModal}
                onClose={() => setOpenDetailsModal(false)}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', md: '88%' },
                        maxWidth: 1300,
                        maxHeight: '92vh',
                        overflowY: 'auto',
                        bgcolor: '#f4f7fb',
                        borderRadius: '24px',
                        p: { xs: 2, md: 4 },
                        boxShadow: '0 20px 60px rgba(0,0,0,0.18)'
                    }}
                >

                    {/* HEADER */}
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #042740 0%, #0b4d78 100%)',
                            borderRadius: '24px',
                            p: { xs: 2.5, md: 4 },
                            color: '#fff',
                            mb: 4
                        }}
                    >
                        <Grid container spacing={3} alignItems="center">

                            <Grid item xs={12} md={8}>

                                <Stack spacing={1}>

                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 700,
                                            letterSpacing: 0.3
                                        }}
                                    >
                                        {selectedInstitute.institute_name}
                                    </Typography>

                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        flexWrap="wrap"
                                        useFlexGap
                                    >

                                        <Chip
                                            label={selectedInstitute.institute_type}
                                            sx={{
                                                bgcolor: 'rgba(255,255,255,0.15)',
                                                color: '#fff',
                                                fontWeight: 600
                                            }}
                                        />

                                        <Chip
                                            label={selectedInstitute.institute_unique_id}
                                            sx={{
                                                bgcolor: 'rgba(255,255,255,0.15)',
                                                color: '#fff'
                                            }}
                                        />

                                    </Stack>

                                </Stack>

                            </Grid>

                            <Grid item xs={12} md={4}>

                                <Stack
                                    direction="row"
                                    justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                >

                                    <Chip
                                        label={selectedInstitute.lead_stage}
                                        sx={{
                                            px: 2,
                                            py: 2.5,
                                            fontWeight: 700,
                                            fontSize: '0.9rem',
                                            color: '#fff',
                                            backgroundColor:
                                                selectedInstitute.lead_stage === 'Active'
                                                    ? '#16a34a'
                                                    : selectedInstitute.lead_stage === 'Onboarding'
                                                        ? '#f59e0b'
                                                        : selectedInstitute.lead_stage === 'Inactive'
                                                            ? '#ef4444'
                                                            : '#64748b'
                                        }}
                                    />

                                </Stack>

                            </Grid>

                        </Grid>
                    </Box>

                    {/* OVERVIEW CARDS */}
                    <Grid container spacing={2} sx={{ mb: 4 }}>

                        <Grid item xs={12} md={3}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent>
                                    <Typography color="text.secondary" fontSize={14}>
                                        Deal Value / Month
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mt: 1,
                                            fontWeight: 700,
                                            color: '#042740'
                                        }}
                                    >
                                        ₹ {selectedInstitute.deal_value_per_month || 0}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent>
                                    <Typography color="text.secondary" fontSize={14}>
                                        Talent Pool
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mt: 1,
                                            fontWeight: 700,
                                            color: '#042740'
                                        }}
                                    >
                                        {selectedInstitute.talent_pool_size_monthly || 0}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent>
                                    <Typography color="text.secondary" fontSize={14}>
                                        Total Hired
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mt: 1,
                                            fontWeight: 700,
                                            color: '#042740'
                                        }}
                                    >
                                        {selectedInstitute.total_hired || 0}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent>
                                    <Typography color="text.secondary" fontSize={14}>
                                        Win Rate
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mt: 1,
                                            fontWeight: 700,
                                            color:
                                                selectedInstitute.win_rate_percentage >= 70
                                                    ? '#16a34a'
                                                    : selectedInstitute.win_rate_percentage >= 40
                                                        ? '#f59e0b'
                                                        : '#ef4444'
                                        }}
                                    >
                                        {selectedInstitute.win_rate_percentage || 0}%
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                    </Grid>

                    {/* BASIC + POC */}
                    <Grid container spacing={3} sx={{ mb: 3 }}>

                        {/* BASIC INFO */}
                        <Grid item xs={12} md={6}>

                            <Card
                                sx={{
                                    height: '100%',
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            mb: 3,
                                            fontWeight: 700,
                                            color: '#042740'
                                        }}
                                    >
                                        Basic Information
                                    </Typography>

                                    <Stack spacing={2.5}>

                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <BusinessIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Institute ID
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_unique_id}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <LocationOnIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Location
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_city},
                                                    {' '}
                                                    {selectedInstitute.institute_country}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <LanguageIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Address
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_location}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                    </Stack>

                                </CardContent>
                            </Card>

                        </Grid>

                        {/* POC */}
                        <Grid item xs={12} md={6}>

                            <Card
                                sx={{
                                    height: '100%',
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            mb: 3,
                                            fontWeight: 700,
                                            color: '#042740'
                                        }}
                                    >
                                        POC Details
                                    </Typography>

                                    <Stack spacing={2.5}>

                                        <Stack direction="row" spacing={2}>
                                            <PersonIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Contact Person
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_uprn_poc_name}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <Stack direction="row" spacing={2}>
                                            <PhoneIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Mobile Number
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_uprn_poc_mobile}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <Stack direction="row" spacing={2}>
                                            <EmailIcon sx={{ color: '#0b4d78' }} />

                                            <Box>
                                                <Typography variant="caption" color="text.secondary">
                                                    Email Address
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    {selectedInstitute.institute_uprn_poc_email}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                    </Stack>

                                </CardContent>
                            </Card>

                        </Grid>

                    </Grid>

                    {/* LANGUAGE & TRAINING */}
                    <Card
                        sx={{
                            mb: 3,
                            borderRadius: 4,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                        }}
                    >
                        <CardContent sx={{ p: 3 }}>

                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 3,
                                    fontWeight: 700,
                                    color: '#042740'
                                }}
                            >
                                Language & Training
                            </Typography>

                            <Box mb={3}>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 1.5,
                                        color: 'text.secondary'
                                    }}
                                >
                                    Core Languages
                                </Typography>

                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>

                                    {
                                        selectedInstitute.institute_core_languages?.map((lang, i) => (
                                            <Chip
                                                key={i}
                                                label={lang}
                                                sx={{
                                                    borderRadius: 2,
                                                    fontWeight: 600,
                                                    bgcolor: '#e6f0f7',
                                                    color: '#0b4d78'
                                                }}
                                            />
                                        ))
                                    }

                                </Stack>

                            </Box>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Language Fees
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.language_fees}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Trainer Level
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.trainer_level}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Training Mode
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.mode_of_training}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Exam Provider
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.exam_provider}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                    {/* STUDENT PIPELINE */}
                    <Card
                        sx={{
                            mb: 3,
                            borderRadius: 4,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                        }}
                    >
                        <CardContent sx={{ p: 3 }}>

                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 3,
                                    fontWeight: 700,
                                    color: '#042740'
                                }}
                            >
                                Student Pipeline
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={6} md={3}>
                                    <Card
                                        sx={{
                                            bgcolor: '#eff6ff',
                                            borderRadius: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                A1
                                            </Typography>

                                            <Typography variant="h4" fontWeight={700}>
                                                {selectedInstitute.nurses_a1 || 0}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <Card
                                        sx={{
                                            bgcolor: '#f5f3ff',
                                            borderRadius: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                A2
                                            </Typography>

                                            <Typography variant="h4" fontWeight={700}>
                                                {selectedInstitute.nurses_a2 || 0}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <Card
                                        sx={{
                                            bgcolor: '#ecfdf5',
                                            borderRadius: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                B1
                                            </Typography>

                                            <Typography variant="h4" fontWeight={700}>
                                                {selectedInstitute.nurses_b1 || 0}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <Card
                                        sx={{
                                            bgcolor: '#fff7ed',
                                            borderRadius: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                B2
                                            </Typography>

                                            <Typography variant="h4" fontWeight={700}>
                                                {selectedInstitute.nurses_b2 || 0}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                    {/* BUSINESS DETAILS */}
                    <Card
                        sx={{
                            borderRadius: 4,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
                        }}
                    >
                        <CardContent sx={{ p: 3 }}>

                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 3,
                                    fontWeight: 700,
                                    color: '#042740'
                                }}
                            >
                                Business Details
                            </Typography>

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Relationship Owner
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.relationship_owner}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Lead Source
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.lead_source}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Agreement Status
                                    </Typography>

                                    <Chip
                                        label={selectedInstitute.agreement_status}
                                        sx={{
                                            mt: 1,
                                            fontWeight: 700,
                                            bgcolor:
                                                selectedInstitute.agreement_status === 'Signed'
                                                    ? '#dcfce7'
                                                    : '#fef3c7',
                                            color:
                                                selectedInstitute.agreement_status === 'Signed'
                                                    ? '#166534'
                                                    : '#92400e'
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Total CVs Shared
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.total_cvs_shared || 0}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Student Tech Level
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.student_tech_level}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography variant="caption" color="text.secondary">
                                        Added By
                                    </Typography>

                                    <Typography fontWeight={600}>
                                        {selectedInstitute.institute_added_by}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>

                </Box>
            </Modal>

            <Modal
                open={props.mystate.openInteractionBox}
                // onClose={() => props.ToggleInteractionBox()}
                onClose={(event, reason) => {
                    // ❌ Prevent close when clicking backdrop
                    if (reason === "backdropClick") return;
                    props.ToggleInteractionBox()
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-Interaction"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Interaction
                    </Typography>
                    <Box mt={1}>
                        <FormControl fullWidth>
                            <TextField
                                select
                                value={props.interactionData.ddlLeadStatus || ''}
                                label="Select Status*"
                                error={props.interactionData.ddlLeadStatusErr == undefined || props.interactionData.ddlLeadStatusErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlLeadStatus')}
                            >

                                <MenuItem key={''} value={'RNR'}>{'RNR'}</MenuItem>
                                <MenuItem key={''} value={'Call Back'}>{'Call Back'}</MenuItem>
                                <MenuItem key={''} value={'Active'}>{'Active'}</MenuItem>
                                <MenuItem key={''} value={'Onboarding'}>{'Onboarding'}</MenuItem>
                                <MenuItem key={''} value={'Inactive'}>{'Inactive'}</MenuItem>

                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadStatusErr}</FormHelperText>
                        </FormControl>
                    </Box>
                    {
                        props.interactionData.ddlLeadStatus === 'Call Back' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtCallBackDateTime')} label="CallBack DateTime*" value={dayjs(props.interactionData.txtCallBackDateTime != undefined ? props.interactionData.txtCallBackDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtCallBackDateTimeErr == undefined || props.interactionData.txtCallBackDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtCallBackDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }
                    {
                        props.interactionData.ddlLeadStatus === 'Onboarding' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtOnboardingDateTime')} label="Onboarding DateTime*" value={dayjs(props.interactionData.txtOnboardingDateTime != undefined ? props.interactionData.txtOnboardingDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtOnboardingDateTimeErr == undefined || props.interactionData.txtOnboardingDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtOnboardingDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'Dead' ?
                            <Box mt={1}>
                                <TextField multiline rows={2} className="text-input" id="txtDeadReason" name='txtDeadReason' error={props.interactionData.txtDeadReasonErr == undefined || props.interactionData.txtDeadReasonErr == '' ? false : true} helperText={props.interactionData.txtDeadReasonErr} onChange={(e) => props.HandleInputs(e, 'txtDeadReason')} value={props.interactionData.txtDeadReason || ''} label="Dead Reason" variant="outlined" />
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtDeadReasonErr}</FormHelperText>
                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadDepartment || ''}
                                        label="Select Department*"
                                        error={props.interactionData.ddlLeadDepartmentErr == undefined || props.interactionData.ddlLeadDepartmentErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                                    >
                                        <MenuItem value={'Sales TL'}>{'Sales TL'}</MenuItem>
                                        <MenuItem value={'Sales'}>{'Sales'}</MenuItem>
                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadDepartmentErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }
                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadOwner || ''}
                                        label="Select Owner*"
                                        error={props.interactionData.ddlLeadOwnerErr == undefined || props.interactionData.ddlLeadOwnerErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                                    >
                                        {
                                            props.mystate.userListData.map((item, i) =>
                                                item.user_profile_name === props.interactionData.ddlLeadDepartment ?
                                                    <MenuItem key={i} value={item.user_name}>{item.user_name}</MenuItem>
                                                    :
                                                    null
                                            )
                                        }


                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadOwnerErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }



                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtInteractionDesc" name='txtInteractionDesc' error={props.interactionData.txtInteractionDescErr == undefined || props.interactionData.txtInteractionDescErr == '' ? false : true} helperText={props.interactionData.txtInteractionDescErr} onChange={(e) => props.HandleInputs(e, 'txtInteractionDesc')} value={props.interactionData.txtInteractionDesc || ''} label="Enter Description" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddNewInteraction()}>Add Interaction</Button>
                            </Grid>

                        </Grid>
                    </Box>

                </Box>
            </Modal>

            {/* ALERT */}
            <Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={1000}
                onClose={() =>
                    props.HandleCloseAlertMsg(
                        props.mystate.alertType
                    )
                }
            >

                <Alert
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>

            </Snackbar>

            <Dialog
                open={props.timelinePopup}
                onClose={() => props.CloseTimeLine()}
                fullWidth
                maxWidth='md'
            >

                <DialogTitle>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >

                        <Typography
                            variant='h6'
                            fontWeight={600}
                        >
                            Institute Timeline
                        </Typography>

                        <IconButton
                            onClick={() => props.CloseTimeLine()}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Box>

                </DialogTitle>

                <DialogContent dividers>

                    <Timeline position='right'>

                        {props.timelineData && props.timelineData.map((item, index) => (

                            <TimelineItem key={index}>

                                <TimelineSeparator>

                                    <TimelineDot
                                        color={
                                            item.timeline_type === 'call'
                                                ? 'success'
                                                : 'primary'
                                        }
                                    >

                                        {
                                            item.timeline_type === 'call'
                                                ? <CallIcon fontSize='small' />
                                                : <ForumIcon fontSize='small' />
                                        }

                                    </TimelineDot>

                                    {
                                        index !== props.timelineData.length - 1 &&
                                        <TimelineConnector />
                                    }

                                </TimelineSeparator>

                                <TimelineContent>

                                    <Box
                                        sx={{
                                            p: 2,
                                            border: '1px solid #e5e7eb',
                                            borderRadius: 2,
                                            mb: 2,
                                            background: '#fff'
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 1,
                                                flexWrap: 'wrap'
                                            }}
                                        >

                                            <Chip
                                                size='small'
                                                label={
                                                    item.timeline_type === 'call'
                                                        ? 'Call'
                                                        : 'Interaction'
                                                }
                                                color={
                                                    item.timeline_type === 'call'
                                                        ? 'success'
                                                        : 'primary'
                                                }
                                            />

                                            <Typography
                                                variant='caption'
                                                color='text.secondary'
                                            >
                                                {item.added_on}
                                            </Typography>

                                        </Box>

                                        {
                                            item.timeline_type === 'interaction' && (

                                                <>

                                                    <Typography
                                                        variant='body2'
                                                        fontWeight={600}
                                                        gutterBottom
                                                    >
                                                        Status :
                                                        {' '}
                                                        {item.interaction_status}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                    >
                                                        {item.description}
                                                    </Typography>

                                                </>

                                            )
                                        }

                                        {
                                            item.timeline_type === 'call' && (

                                                <>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Call Status :
                                                        {' '}
                                                        <b>
                                                            {item.call_status}
                                                        </b>
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        From :
                                                        {' '}
                                                        {item.call_from_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        To :
                                                        {' '}
                                                        {item.call_to_number}
                                                    </Typography>

                                                    <Typography
                                                        variant='body2'
                                                        gutterBottom
                                                    >
                                                        Duration :
                                                        {' '}
                                                        <b>
                                                            {formatDuration(item.duration)}
                                                        </b>
                                                    </Typography>

                                                    {
                                                        item.recording_url && (

                                                            <Box sx={{ mt: 2 }}>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ mb: 1 }}
                                                                >
                                                                    <b>Recording</b>
                                                                </Typography>

                                                                <audio
                                                                    controls
                                                                    preload="none"
                                                                    style={{
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    <source src={item.recording_url} />
                                                                </audio>
                                                            </Box>

                                                        )
                                                    }

                                                    <Typography
                                                        variant='body2'
                                                    >
                                                        By :
                                                        {' '}
                                                        {item.call_by}
                                                    </Typography>

                                                </>

                                            )
                                        }

                                    </Box>

                                </TimelineContent>

                            </TimelineItem>

                        ))}

                    </Timeline>

                </DialogContent>

            </Dialog>

        </Box>
    );
};